import { Chip } from '@mui/material'
import { CRASH_KIND_COLOR, crashKindLabel } from './crashFormat'

export function CrashKindChip({ kind, size = 'small' }: { kind: string; size?: 'small' | 'medium' }) {
  return (
    <Chip
      label={crashKindLabel(kind)}
      size={size}
      color={CRASH_KIND_COLOR[kind] ?? 'default'}
      variant="outlined"
      sx={{ whiteSpace: 'nowrap' }}
    />
  )
}
